"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = uniqueId;
const nanoid_1 = require("nanoid");
const non_secure_1 = require("nanoid/non-secure");
const environment_1 = require("../../lib/environment");
function uniqueId() {
    return environment_1.isReactNative ? (0, non_secure_1.nanoid)() : (0, nanoid_1.nanoid)();
}
//# sourceMappingURL=uniqueId.js.map